import {
  CommissionStatus,
  PayoutStatus,
  ReferralType,
} from "types/affiliation.types";
import {
  AffiliationTabs,
  EarningsPieChartKeys,
  PayoutsStatistics,
  ReferralLinksStatistics,
  ReferralLinksStatisticsValues,
} from "features/affiliation/common/types";
import { LanguageNameSpaces, PaymentMethodType } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";

export const AFFILIATION_SMALL_SCREEN = "1250px";
export const PAYOUTS_MOBILE = "900px";
export const SMALL_TITLE_SCREEN = "1400px";
export const TAB_AND_BUTTONS_IN_ROW = "1250px";
export const OVERVIEW_SMALL_SCREEN_LAYOUT = "1475px";
export const MINIFIED_TIERS = "1050px";

export const PAYOUT_SERVICES = [
  PaymentMethodType.PAYPAL,
  PaymentMethodType.CRYPTO,
];

export const PAYOUT_SERVICE_DISPLAY_NAME = {
  [PaymentMethodType.PAYPAL]: "PayPal",
  [PaymentMethodType.CRYPTO]: "Crypto",
};

export const USD_PRECISION = 2;
export const USERS_TAB_TO_REFERRAL_TYPE = {
  [AffiliationTabs.REFERRED_USERS]: ReferralType.PAYOUTS,
  [AffiliationTabs.EXISTING_USERS]: ReferralType.PROMO_CODE,
};

export const EARNINGS_PIE_CHART_KEY_TO_HELPER_TOOLTIP = {
  [EarningsPieChartKeys.AMOUNT_EARNED]:
    "earnings.pie_chart_tooltips.amount_earned",
  [EarningsPieChartKeys.AMOUNT_NOT_CONFIRMED]:
    "earnings.pie_chart_tooltips.amount_not_confirmed",
};

export const AFFILIATION_ARTICLE_ID = "6814831";

export const TIER_TO_DISPLAY_NAME = {
  1: "tiers.first_tier",
  2: "tiers.second_tier",
  3: "tiers.third_tier",
};

export const EARNINGS_PIE_CHART_KEY_TO_STATUS: {
  [key in EarningsPieChartKeys]: CommissionStatus;
} = {
  [EarningsPieChartKeys.AMOUNT_NOT_CONFIRMED]: CommissionStatus.PENDING,
  [EarningsPieChartKeys.AMOUNT_EARNED]: CommissionStatus.APPROVED,
};

export const EARNINGS_PIE_CHART_KEY_TO_VALUE_COLOR: {
  [key in EarningsPieChartKeys]: string;
} = {
  [EarningsPieChartKeys.AMOUNT_NOT_CONFIRMED]: "red",
  [EarningsPieChartKeys.AMOUNT_EARNED]: "green",
};

export const PAYOUTS_STATISTIC_TITLE_TO_STATUS: {
  [title in PayoutsStatistics]: PayoutStatus;
} = {
  [PayoutsStatistics.PENDING_PAYOUTS]: PayoutStatus.PENDING,
  [PayoutsStatistics.AMOUNT_AWAITING_APPROVAL]: PayoutStatus.PENDING,
  [PayoutsStatistics.PROCESSED_PAYOUTS]: PayoutStatus.APPROVED,
  [PayoutsStatistics.PAID_TO_DATE]: PayoutStatus.APPROVED,
};

export const LINKS_STATISTIC_TITLE_TO_VALUE: {
  [titleName in ReferralLinksStatistics]: keyof ReferralLinksStatisticsValues;
} = {
  [ReferralLinksStatistics.NUM_OF_LINKS]: "referral_code",
  [ReferralLinksStatistics.TOTAL_CLICKS]: "clicks",
  [ReferralLinksStatistics.REFERRED_USERS]: "registered_users",
  [ReferralLinksStatistics.PAID_USERS]: "paid_users",
};

export const CREATE_PAYOUT_MIN_AMOUNT = 100;

export const COMMISSION_STATUS_DISPLAY_NAME = {
  [CommissionStatus.PENDING]: "earnings.status_display_name.pending",
  [CommissionStatus.APPROVED]: "earnings.status_display_name.confirmed",
  [CommissionStatus.CANCELLED]: "earnings.status_display_name.denied",
  [CommissionStatus.PAYMENT_REFUNDED]:
    "earnings.status_display_name.payment_refunded",
};

export const PAYOUTS_STATUS_DISPLAY_NAME: Record<
  PayoutStatus,
  TranslationKeys<LanguageNameSpaces.AFFILIATION>
> = {
  [PayoutStatus.PENDING]: "payouts.status_display_name.awaiting_approval",
  [PayoutStatus.APPROVED]: "payouts.status_display_name.paid",
  [PayoutStatus.CANCELLED]: "payouts.status_display_name.cancelled",
  [PayoutStatus.DENIED]: "payouts.status_display_name.denied",
};
